
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.395 28.5H9.75a6.75 6.75 0 01-1.516-13.329c.65-4.3 4.364-7.671 8.932-7.671h.787c3.76 0 6.883 2.471 7.948 5.805 3.916.254 7.099 3.516 7.099 7.59 0 4.2-3.405 7.605-7.605 7.605zm.88-12.127a4.608 4.608 0 00-1.388-.055l-1.637.182a5.31 5.31 0 00-.276-2.48 5.339 5.339 0 00-5.02-3.52h-.788a6.036 6.036 0 00-5.916 4.84 6.038 6.038 0 00-.087 1.793l.087.867h-1.5a3.751 3.751 0 000 7.5h15.645a4.605 4.605 0 00.88-9.127z","fill":"#0ABEC3"}})])
          )
        }
      }
    